export const CLIENT = 'CLIENT';
export const OPERATOR_ADMIN = 'OPERATOR_ADMIN';
export const PARTNER_ADMIN = 'PARTNER_ADMIN';
export const PARTNER_MANAGER = 'PARTNER_MANAGER';
export const GUEST = 'GUEST';
